import { BuildNode, NodeStates, ProductVariationsNode } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { ProductVariation } from "../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import VariationOption from "./VariationOption";

interface VariationProps {
    node: BuildNode;
    variation: ProductVariation;
    formatC: (amount: number) => string;
    onSelect?: (value: { value: string; name: string }) => void;
    builder?: boolean;
    nodeState?: NodeStates;
    disabled?: boolean;
}

const Variation = ({ node, variation, formatC, onSelect, builder, nodeState, disabled }: VariationProps) => {
    const { setElement, states } = useInteractionStates<HTMLDivElement>();
    const pVarNode = node as ProductVariationsNode;
    const { stateManager, attr, groupFontStyles, optionWrapperStyles } = pVarNode;

    if (builder) {
        const groupFontStylesWithState = getCompoundStyle({
            otherStyle: groupFontStyles,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "groupFontStyles")
        });
        const optionWrapperStylesWithState = getCompoundStyle({
            otherStyle: optionWrapperStyles,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "optionWrapperStyles")
        });

        return (
            <div className="variation">
                <p
                    style={{
                        ...groupFontStylesWithState,
                        ...(attr?.style?.alignItems === "flex-end" ? { alignSelf: "flex-end" } : {})
                    }}
                >
                    {variation.label}
                </p>
                <div className="variation-options" style={optionWrapperStylesWithState}>
                    {variation.options.map((option, index) => (
                        <VariationOption
                            key={index}
                            node={node}
                            name={variation.label}
                            option={option}
                            formatC={formatC}
                            onSelect={onSelect}
                            builder
                            nodeState={nodeState}
                        />
                    ))}
                </div>
            </div>
        );
    } else {
        const groupFontStylesWithState = getStylesFromInteractiveStates({
            states,
            defaultStyle: groupFontStyles,
            stateManager,
            paths: ["groupFontStyles"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        const optionWrapperStylesWithState = getStylesFromInteractiveStates({
            states,
            defaultStyle: optionWrapperStyles,
            stateManager,
            paths: ["optionWrapperStyles"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <div className="variation" ref={setElement}>
                <p
                    style={{
                        ...groupFontStylesWithState,
                        ...(attr?.style?.alignItems === "flex-end" ? { alignSelf: "flex-end" } : {})
                    }}
                >
                    {variation.label}
                </p>
                <div className="variation-options" style={optionWrapperStylesWithState}>
                    {variation.options.map((option, index) => (
                        <VariationOption
                            key={index}
                            node={node}
                            name={variation.label}
                            option={option}
                            formatC={formatC}
                            onSelect={onSelect}
                        />
                    ))}
                </div>
            </div>
        );
    }
};

export default Variation;
